(function () {
    'use strict';

    angular
        .module('app.gameTracker')
        .component('sc3GameTrackerRecovery', {
            templateUrl: 'app/game-tracker/recovery/game-tracker-recovery.component.html',
            controller: GameTrackerRecoveryComponent,
            bindings: {
                data: '<'
            }
        });

    GameTrackerRecoveryComponent.$inject = ['gameTrackerChartFactory'];
    function GameTrackerRecoveryComponent(gameTrackerChartFactory) {
        var ctrl = this;
        ctrl.chart = null;
        ctrl.$onInit = init;

        ///////////////////////////////////////////////////////////

        function init() {
            ctrl.chart = gameTrackerChartFactory(ctrl.data.summary);
            ctrl.chart.options = {
                scales: {
                    xAxes: [{ ticks: { suggestedMin: 0, suggestedMax: 100 } }]
                },
                tooltips: {
                    callbacks: {
                        title: function (tooltipItems, data) { return '';                         },
                        label: function (tooltipItem, data) {
                            return data.labels[tooltipItem.index] + ': ' + tooltipItem.xLabel.toFixed(1) + '%';
                        }
                    }
                }
            };
        }
    }
})();